import { forwardRef, useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import BodyMapEntryTemplate from "../templates/BodyMapEntryTemplate";

interface Ref {
  show: () => void;
}

interface Props {
  residentId: number;
  entryId: number;
  locations: string[];
}

const UpdateBodyMapEntryModal = forwardRef<Ref, Props>(
  ({ residentId, entryId, locations }, ref) => {
    const [showing, setShowing] = useState(false);

    useImperativeHandle(ref, () => ({
      show: () => {
        setShowing(true);
      },
    }));

    const handleClose = () => {
      setShowing(false);
    };

    return (
      <ReusableModal
        isVisible={showing}
        onClose={handleClose}
        className="w-full max-w-[984px] mx-auto"
        title="Resident Body Map"
        hasCancelButton
      >
        <BodyMapEntryTemplate
          residentId={residentId}
          entryId={entryId}
          locations={locations}
          onClose={handleClose}
        />
      </ReusableModal>
    );
  },
);

UpdateBodyMapEntryModal.displayName = "UpdateBodyMapEntryModal";
export { UpdateBodyMapEntryModal };
